module.exports = __webpack_public_path__ + "static/media/faan_logo2.b8d8c1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faan_logo2.png
// module id = 1053
// module chunks = 0